import UrqlClient from '@/app/graphql/client';
import { getSdk } from './sdk.rule-engine';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

const client = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-rule-engine-service/graphql`);
const sdkRuleEngineService = getSdk(client);

export * from './sdk.rule-engine';
export default sdkRuleEngineService;
